// extracted by mini-css-extract-plugin
module.exports = {"desk":"CardData_desk__1GGhz","mob":"CardData_mob__QCrxg"};